export const DEFAULT_TOKEN = 'guest'
